import { render, staticRenderFns } from "./SafetyProductionList.vue?vue&type=template&id=3cf5b63f&scoped=true&"
import script from "./SafetyProductionList.vue?vue&type=script&lang=js&"
export * from "./SafetyProductionList.vue?vue&type=script&lang=js&"
import style0 from "./SafetyProductionList.vue?vue&type=style&index=0&id=3cf5b63f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf5b63f",
  null
  
)

export default component.exports